var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotificationStreamSummary = function SvgNotificationStreamSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 42",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z",
    fill: "url(#notificationStreamSummary_svg__gpz8aa4dda)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.662 18.734l-8.344 8.344-4.4-4.4-6.578 6.596",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.09 18.734h6.572v6.572",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "notificationStreamSummary_svg__gpz8aa4dda",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 17.28) scale(26.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgNotificationStreamSummary;